import React, { Component } from "react";
import "./blogcontent.css";
import firebase from "firebase";
import moment from "moment";
import Loader from "../../components/loader/loader";

export default class Blogcontent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blog: {},
      loading: true,
    };
  }

  componentDidMount() {
    firebase
      .firestore()
      .collection("blog")
      .doc(this.props.match.params.id)
      .onSnapshot((doc) => {
        this.setState({
          blog: doc.data(),
          loading: false,
        });
      });
  }

  render() {
    return (
      <>
        {this.state.loading ? <Loader/> : (
          <div className="blog-wholepage">
            <div className="opacity"></div>
            <div className="blog-content-firstsec">
              <h1>{this.state.blog.title}</h1>
              <div className="line"></div>
            </div>
            <div className="blog-body">
              <img src={this.state.blog.image1} alt="blog1" />
              <p>{this.state.blog.content}</p>
              <img src={this.state.blog.image2} alt="blog1" />
              <h3>
                Author :<span>{this.state.blog.author}</span>
              </h3>
              <p>
                <span>
                  {moment(this.state.blog.date.toDate()).format("ll")}
                </span>
              </p>
            </div>
          </div>
        )}
      </>
    );
  }
}
